import { Platform } from 'react-native';

export const config = {
  appId:
    Platform.OS === 'ios'
      ? '1:135949499765:ios:d198ba56dda331bf42a73c'
      : '1:135949499765:android:56d3c077afda047d42a73c',
  apiKey:
    Platform.OS === 'ios'
      ? 'AIzaSyDxIzzTwMOy8r9huJH9Wj0Rx96ycC6qjXQ'
      : 'AIzaSyBW6JHeQD8Is9CbUMMVngXjtMfnTblk8PE',
  projectId: 'bizpluspos-app',
  storageBucket: 'bizpluspos-app.firebasestorage.app',
  messagingSenderId: '135949499765',
  databaseURL: '',
};
